<template>
  <div class="home">
    <student-home-page v-if="isStudent"/>
    <teacher-home-page v-if="isTeacher"/>
    <manager-home-page v-if="isManager"/>
    <admin-home-page v-if="isAdmin"/>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import AdminHomePage from './staff/1.home/AdminHomePage.vue';
import StudentHomePage from './student/1.home/StudentHomePage.vue';
import ManagerHomePage from './staff/1.home/ManagerHomePage.vue';
import TeacherHomePage from './staff/1.home/TeacherHomePage.vue';
export default {
  name: 'Home',
  components: { StudentHomePage, ManagerHomePage, AdminHomePage, TeacherHomePage },
  computed: {
    ...mapState('auth', ['profile']),
    ...mapGetters('auth', ['isStudent', 'isStaff', 'isManager', 'isTeacher', 'isAdmin'])
  }
}
</script>
